import { TruckIcon, WalletIcon, ShieldIcon } from './Icons';

const trustItems = [
  {
    icon: TruckIcon,
    title: 'Livraison rapide',
    desc: 'À domicile ou au bureau',
  },
  {
    icon: WalletIcon,
    title: 'Paiement sécurisé',
    desc: 'En ligne ou à la livraison',
  },
  {
    icon: ShieldIcon,
    title: 'Satisfait ou remboursé',
    desc: 'Votre satisfaction est notre priorité',
  },
];

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-trust">
        {trustItems.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="trust-item">
            <div className="trust-icon">
              <Icon size={24} />
            </div>
            <div>
              <p className="trust-title">{title}</p>
              <p className="trust-desc">{desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="footer-copy-bar">
        <div className="footer-copy">
          <p className="footer-credit">
            Réalisé par{' '}
            <a
              href="https://dowhile.tech/"
              className="footer-credit-brand"
              target="_blank"
              rel="noopener noreferrer"
            >
              Dowhile SARL
            </a>
          </p>
          <p className="footer-copy-text">
            © {new Date().getFullYear()} DoWhile Food — Yaoundé, Cameroun — Tous droits réservés
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
